import React, { useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const ExemploApiClient = () => {
  const { request, data, isLoading } = useApiClient();

  useEffect(() => {
    request(apiRoutes.auth.autenticacao.getCaptcha);
  }, [request]);

  return (
    <div style={{ backgroundColor: "white", padding: "20px" }}>
      <h1>Exemplo utilizando o Api Client Hook</h1>
      <Button
        variant="primary"
        onClick={() => {
          request(apiRoutes.auth.autenticacao.getCaptcha);
        }}
      >
        Recarregar captcha
      </Button>
      <br />
      <br />
      <b>Imagem:</b>
      <br />
      {isLoading ? (
        <span>
          <Spinner animation="border" role="status" />
          Buscando imagem...
        </span>
      ) : (
        data && <img alt="Captcha" src={data.result.arquivo} />
      )}
    </div>
  );
};

export default ExemploApiClient;
